import type { ParamMap } from '@angular/router';

import { BusinessUnit, DEFAULT_BUSINESS_UNIT } from '~shared/business-unit';
import { StoreLocatorRegion } from '~shared/store-locator-region';

/**
 * Gets the region for a given business unit
 * @param bu - The business unit code
 * @returns The region ('us' or 'eu')
 */
export const getRegionFromBu = (bu: BusinessUnit): StoreLocatorRegion => {
  // Default to 'us' if bu is undefined or null
  if (!bu || bu === BusinessUnit.US || bu === BusinessUnit.CA || bu === BusinessUnit.Mock) return StoreLocatorRegion.US;

  return StoreLocatorRegion.EU;
};

/**
 * Gets the country code for a given business unit
 * @param bu - The business unit code
 * @returns The country code to use in API calls
 */
export const getCountryFromBu = (bu: BusinessUnit): BusinessUnit => {
  // Default to 'us' if bu is undefined, null, or mock
  if (!bu || bu === BusinessUnit.Mock) return BusinessUnit.US;

  return bu;
};

/**
 * Gets the business unit from route query params
 * @param params - The route's query param map
 * @returns The business unit from the `bu` query param, or the default if absent
 */
export const getBuFromQueryParams = (params: ParamMap): BusinessUnit =>
  (params.get('bu') as BusinessUnit | null) ?? DEFAULT_BUSINESS_UNIT;
